/** Locales seeded in every block fixture (matches onboarding defaults). */
export const FIXTURE_LOCALES = ['de', 'en'] as const;

export type FixtureLocale = (typeof FIXTURE_LOCALES)[number];

export function loc2(de: string, en: string): Record<FixtureLocale, string> {
  return { de, en };
}

/** Legacy 3-arg helper — third value is ignored after VI removal from design-lab fixtures. */
export function loc3(de: string, en: string, _vi?: string): Record<FixtureLocale, string> {
  return loc2(de, en);
}
